import { render } from "./PrenotazioniSetting.vue?vue&type=template&id=7f678d30&scoped=true"
import script from "./PrenotazioniSetting.vue?vue&type=script&lang=js"
export * from "./PrenotazioniSetting.vue?vue&type=script&lang=js"

import "./PrenotazioniSetting.vue?vue&type=style&index=0&id=7f678d30&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f678d30"]])

export default __exports__